module.exports = __webpack_public_path__ + "static/media/add-recipe-black.bd4df32e.svg";